import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterAuto'
})
export class FilterAutoPipe implements PipeTransform {
    transform(items: any[], term): any {
        return term 
            ? items.filter(item => ((item.registracija && item.registracija.toLowerCase().indexOf(term.toLowerCase()) !== -1) || (item.vin && item.vin.toLowerCase().indexOf(term.toLowerCase()) !== -1)))
            : items;
    }
}

@Pipe({
  name: 'filterSifrarnik'
})
export class FilterSifrarnikPipe implements PipeTransform {
    transform(items: any[], term): any {
        return term 
            ? items.filter(item => ((item.naziv && item.naziv.toLowerCase().indexOf(term.toLowerCase()) !== -1)))
            : items;
    }
}